module.exports = __webpack_public_path__ + "static/media/select-arrows.0a0b0e16.svg";